import React, { Component } from 'react';
import logo from '../../Logo_Gregg.svg';
import confirm from '../../confirm.svg';
import './index.css'

import {Link} from 'react-router-dom';

class CupomRescued extends Component {
  render() {
    return (
      <div className="text-center">
        <img className="gregg-logo" src={logo} alt="gregg" width="135"/>
        <img className="confirm-icon" src={confirm} alt="ícone de checked" width="70" />
        <div className="content-container text-center">
          <h2 className="text-center">Resgate efetuado!</h2>
          <p>{this.props.location.state.name} realizou o resgate com sucesso!</p>
        </div>
        <Link className="check-again" to={`/`}>Nova consulta</Link>
      </div>
    )
  }
}

export default CupomRescued;



// WEBPACK FOOTER //
// ./src/components/cupomrescued/index.js